import styled from "styled-components";

export const ButtonDelete = styled.button`
  margin-left: 5px;
  padding: 0px 5px;
`;

export const ListField = styled.ul`
  list-style: none;
`;

export const ItemField = styled.li`
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
  border-bottom: 1px solid #ccc;
`;

export const ConfirmFile = styled.span`
  color: green;
  font-size: 1rem;
  font-weight: bold;
`;

export const ListError = styled.ul`
  margin-bottom: 0px !important;
`;

export const FormContainer = styled.div`
  width: 100%;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const Header = styled.div`
  background: linear-gradient(135deg, #2c3e35 0%, #1a2822 100%);
  padding: 2rem 2.5rem;
  color: #fff;

  @media (max-width: 768px) {
    padding: 1.5rem 1.5rem;
  }

  @media (max-width: 480px) {
    padding: 1rem 1rem;
  }
`;

export const HeaderTitle = styled.h1`
  font-size: 1.75rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: #fff;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }

  @media (max-width: 480px) {
    font-size: 1.25rem;
  }
`;

export const HeaderSubtitle = styled.p`
  font-size: 0.95rem;
  margin: 0;
  color: rgba(255, 255, 255, 0.85);
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }

  @media (max-width: 480px) {
    font-size: 0.8rem;
  }
`;

export const FormBody = styled.div`
  padding: 2.5rem;

  @media (max-width: 768px) {
    padding: 1.5rem;
  }

  @media (max-width: 480px) {
    padding: 1rem;
  }
`;

export const FormSection = styled.div`
  margin-bottom: 2rem;

  .form-control,
  .input-wrapper {
    width: 100%;
  }
`;

export const SectionLabel = styled.label`
  display: block;
  font-size: 0.95rem;
  font-weight: 600;
  color: #2c3e35;
  margin-bottom: 0.5rem;

  ${(props) =>
    props.mandatory &&
    `
    &::after {
      content: " *";
      color: #dc3545;
    }
  `}
`;

export const HelpText = styled.p`
  font-size: 0.85rem;
  color: #6c757d;
  margin: 0.5rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  i {
    color: #f9ae17;
  }
`;

export const LocationsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
`;

export const LocationList = styled.div`
  height: 300px;
  overflow-y: auto;
  overflow-x: hidden;

  @media (max-width: 768px) {
    height: 250px;
  }

  @media (max-width: 480px) {
    height: 200px;
  }

  .no-items,
  .no-items-selected {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #adb5bd;
    font-size: 0.9rem;
    text-align: center;
    padding: 2rem;

    @media (max-width: 480px) {
      padding: 1rem;
      font-size: 0.8rem;
    }
  }

  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f8f9fa;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: 4px;

    &:hover {
      background: #a0aec0;
    }
  }
`;

export const TransferButtons = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem 0;

  @media (max-width: 768px) {
    flex-direction: row;
    gap: 0.25rem;
    padding: 0.5rem 0;
  }

  @media (max-width: 480px) {
    flex-direction: row;
    justify-content: center;
    gap: 0.25rem;
    flex-wrap: wrap;
    padding: 0.5rem 0;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 0.75rem;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

export const CancelButton = styled.button`
  background: #6c757d;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 1rem 2rem;
  font-size: 1.05rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 150px;

  &:hover {
    background: #5a6268;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    padding: 0.8rem 1.5rem;
    font-size: 0.95rem;
    min-width: 120px;
  }

  @media (max-width: 480px) {
    width: 100%;
    padding: 0.7rem 1rem;
    font-size: 0.85rem;
    min-width: unset;
  }
`;

export const ActionButton = styled.button`
  background: #f9ae17;
  color: #2c3e35;
  border: none;
  border-radius: 6px;
  padding: 1rem 2rem;
  font-size: 1.05rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 200px;

  &:hover {
    background: #e89d0f;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(249, 174, 23, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    padding: 0.8rem 1.5rem;
    font-size: 0.95rem;
    min-width: 150px;
  }

  @media (max-width: 480px) {
    width: 100%;
    padding: 0.7rem 1rem;
    font-size: 0.85rem;
    min-width: unset;
  }
`;
